<ngx-spinner name="fullPageLoader" bdColor="rgb(107 152 195 / 15%)" size="medium" color="#2173c5" type="ball-clip-rotate" [fullScreen]="true">
  <p class="text-primary"> Loading... </p>
</ngx-spinner>
<ngx-loading-bar color="#b7997d" height="7px" diameter="25px"></ngx-loading-bar>
<router-outlet></router-outlet>
